import { RefObject, useEffect, useRef } from 'react';

export function useInputFocus<T extends HTMLInputElement | HTMLTextAreaElement>(
  active: boolean = true,
): RefObject<T> {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!active) return;
    const element = ref.current;
    if (!element) return;
    element.focus();
    element.select();
  }, [active]);

  return ref;
}
